import ActionsForm from '@/shared/mixins/actionsForm'
import Searchaccredited from './components/searchaccredited/searchaccredited.vue'
import Tableaccredited from './components/tableaccredited/tableaccredited.vue'
import Newaccredited from './components/newaccredited/newaccredited.vue'
import Abstractaccredited from './components/abstractaccredited/abstractaccredited.vue'
import Painelaccredited from './components/painelaccredited/painelaccredited.vue'
import AccrediteddateRepository from '@/shared/http/repositories/realestate/accrediteddate'
import { toast, loading } from '@/shared/utils/UIHelper'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  mixins: [ActionsForm, PermissionMixin],
  components: {Searchaccredited, Tableaccredited, Newaccredited, Abstractaccredited, Painelaccredited},
  name: 'Accredited',
  data () {
    return {
      flDetails: false,
      dataDetails: {},
      keyTableAccredited: 0,
      keyAbstractaccredited: 0,
      roles: Roles,
      isAccreditedSelected: false
    }
  },
  methods: {
    setfldetails (obj) {
      this.dataDetails = obj
    },
    edit (editSelected) {
      this.dataDetails = editSelected
      this.flDetails = true
    },
    updateView (newV) {
      this.flDetails = newV
    },
    updateTableAccredited () {
      this.keyTableAccredited++
    },

    updateAbstractaccredited () {
      this.keyAbstractaccredited++
    },

    deleteAccredited (Accredited) {
      AccrediteddateRepository.DeleteAccredited(Accredited.id)
        .then(res => {
          if (res.status === 200) {
            this.updateTableAccredited()
            toast.success(`Credenciada excluida com sucesso`)
            loading.pop()
          }
        })
        .catch(() => {
          toast.error(`Erro ao excluir a Credenciada`)
          loading.pop()
        })
    },

    GetFilter (filter, isFilter) {
      this.$refs.TableaccreditedComponent.searchWithFilter(filter, isFilter)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/accredited.js